<template>
  <div class="information">
    <div class="pd-t30 pd-b50">
      <div class="details-box">
        <div class="mg-b20">
          <div class="f20 text-bold">
            一、行业资质
          </div>
          <p>公司全称：和德保险经纪有限公司</p>
          <p>公司官网：www.hedejj.com</p>
          <p>注册地址：北京市丰台区丽泽路16号院4号楼8层801内02A单元</p>
          <p>联系电话：010-87878876</p>
        </div>
        <div class="f20 text-bold">营业执照与保险中介许可证</div>
        <div class="mg-b50">
          <img class="max-w100p" :src="'/static/images/information/information_img_01.jpg'" alt="">
        </div>
        <div class="mg-b50">
          <img class="max-w100p" :src="'/static/images/information/information_img_02.jpg'" alt="">
        </div>
        <div class="f20 text-bold">公司基本信息公示（含业务范围、经营区域和主要负责人姓名）</div>
        <div class="mg-b50">
          <img class="max-w100p" :src="'/static/images/information/information_img_04.jpg'" alt="">
        </div>
        <div class="mg-b50">
          <div class="f20">自营网络平台中国保险行业协会官方网站信息披露链接</div>
          <p>查询方法：登录网址“http://icid.iachina.cn/” >信息披露>互联网保险信息披露></p>
          <p>搜索“和德保险经纪有限公司”即可查看。</p>
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">二、自营网络平台名称、地址、信息系统安全等级保护备案证明</div>
          <p>网站：和德经纪 网址：www.hedejj.com commmonh5.hedejj.com qsgz.hedejj.com 京ICP备 13023906号</p>
          <p>旅游保险服务平台 网址：youxingbao.hedejj.com 京ICP备 13023906号</p>
          <p>微信公众号：和德保险经纪；校园保险服务平台</p>
          <!--          <p>微信小程序：速保易</p>-->
        </div>
        <div class="f20 text-bold">信息系统安全等级保护备案证明</div>
        <div class="mg-b50">
          <img class="max-w100p" :src="'/static/images/information/information_img_03.jpg'" alt="">
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">三、互联网保险产品信息</div>
          <p><a class="color-blue" href="javascript:void(0)"
                onclick="window.open('https://docs.qq.com/sheet/DYWJGclhTclpNeUJH?tab=BB08J2', '_blank')">互联网保险产品信息.xlsx</a>
          </p>
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">四、互联网保险产品及保单的查询和验真途径</div>
          <p>您可通过保险产品对应承保公司官方网站及客服热线查询保单情况或保单验真。</p>
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">五、客户服务及消费者投诉方式</div>
          <p>客服电话：400-004-8787</p>
          <p>电话投诉：010-87878876</p>
          <p>上门及信函投诉地址：北京市丰台区丽泽路16号院4号楼8层801内02A单元，邮编 100073</p>
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">六、保险机构合作情况</div>
          <p><a class="color-blue" href="javascript:void(0)"
                onclick="window.open('https://docs.qq.com/sheet/DYWJGclhTclpNeUJH?tab=zwvtyi', '_blank')">保险机构合作情况.xlsx</a>
          </p>
        </div>
        <div class="mg-b50">
          <div class="f20 text-bold">七、分支机构情况</div>
          <p>二级机构详情：</p>
          <p>和德保险经纪有限公司山西分公司</p>
          <p>办公地址：山西省太原市晋源区金胜镇新晋祠路480号全景晋阳湖C座26层2607号</p>
          <p>电话号码：18534605932</p>
          <p>和德保险经纪有限公司青岛分公司</p>
          <p>办公地址：山东省青岛市莱西市夏格庄镇梦鲤大街43-109-1号</p>
          <p>电话号码：18653167755</p>
          <p>和德保险经纪有限公司内蒙古分公司</p>
          <p>办公地址：内蒙古自治区呼和浩特市经济技术开发区科尔沁南路69号呼和浩特留学人员创业园创新创业大厦主楼1111房间</p>
          <p>电话号码：0471-6552657</p>
          <p>和德保险经纪有限公司广东分公司</p>
          <p>办公地址：珠海市拱北迎宾南路2230号4J房</p>
          <p>电话号码：15323631319</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "information",

  mounted() {
    // window.open('http://portal.hedejj.com/disclosure', '_blank')
  }

}
</script>

<style>
.information .details-box {
  color: #7a6a56;
}

.information .details-box p {
  font-size: 16px;
  line-height: 30px;
}
</style>